<div class='wrapperSpinner' [class.wrapperSpinner--positionAbsolute]='positionAbsolute'>
  <mat-spinner [diameter]='diameter'></mat-spinner>
</div>